import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
class Cell {
    constructor(scene, x, y, index, reel) {
        this.on = true;
        this.memo = 0;
        this.multiplierValue = 0;
        this.scene = scene;
        this.gameLogicVariableManager = window.GameLogicVariableManager;
        this.reel = reel;
        this.x = x;
        this.y = y;
        this.index = index;
        this.baseSymbolSpineRaw = ResourcesDispatcher.GAME_CONSTANTS.symbolSpines;
        this.baseSymbolImageRaw = ResourcesDispatcher.GAME_CONSTANTS.symbolImagesOn;
        this.baseSymbolImage = this.scene.add.image(0, 0, this.getSymbolImageRaw(0).key, this.getSymbolImageRaw(0).frame).setOrigin(0.5);
        this.baseSymbolSpines = [];
        for (let i = 0; i < this.baseSymbolSpineRaw.length; i++) {
            const spine = this.scene.add.spine(0, 0, this.getSymbolSpineRaw(i).jsonKey, this.getSymbolSpineRaw(i).atlasKey).setOrigin(0.5).setVisible(false);
            this.baseSymbolSpines.push(spine);
        }
        let linkFont = this.scene.globalVariableManager.getFont().overrideFont({ fontSize: 50, color: "#FF0000" });
        this.linkSpineValueText = this.scene.add.text(0, 0, "", linkFont).setOrigin(0.5);
        this.baseGameContainer = this.scene.add.container(0, 0, [this.baseSymbolImage, ...this.baseSymbolSpines]);
        this.linkSpinContainer = this.scene.add.container(0, 0, [this.linkSpineValueText]).setVisible(false);
        this.container = this.scene.add.container(this.x, this.y, [this.baseGameContainer, this.linkSpinContainer]);
    }
    setOn(on) {
        this.on = on;
    }
    setMemo(memo) {
        this.memo = memo;
    }
    setIndex(index) {
        this.index = index;
    }
    /** PUBLIC GETTERS **/
    getOn() {
        return this.on;
    }
    getMemo() {
        return this.memo;
    }
    getContainer() {
        return this.container;
    }
    getBaseContainer() {
        return this.baseGameContainer;
    }
    getLinkSpinContainer() {
        return this.linkSpinContainer;
    }
    getIndex() {
        return this.index;
    }
    getSymbolSpines() {
        return this.baseSymbolSpineRaw;
    }
    getSymbolSpineRaw(memo) {
        return this.baseSymbolSpineRaw[memo];
    }
    getSpine(memo) {
        return this.baseSymbolSpines[memo];
    }
    getImage() {
        return this.baseSymbolImage;
    }
    /*******************/
    /** PRIVATE GETTERS **/
    getExtraWildSpine() {
        return this.baseSymbolSpines[ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD];
    }
    getSymbolImageRaw(memo) {
        return this.baseSymbolImageRaw[memo];
    }
    /*******************/
    applySymbolTint(memo, isOn) {
        this.baseSymbolImage.setTexture(this.getSymbolImageRaw(memo).key, this.getSymbolImageRaw(memo).frame);
        this.baseSymbolImage.setTint(isOn ? 0xFFFFFF : 0x7F7F7F);
    }
    turnOn() {
        this.on = true;
        this.applySymbolTint(this.getMemo(), true);
        this.reel.expandingWild?.turnOnWildAnimation();
    }
    turnOff() {
        this.on = false;
        this.applySymbolTint(this.getMemo(), false);
        this.stopAnimation();
        this.reel.expandingWild?.turnOffWildAnimation();
    }
    resetLayer() {
        if (!this.reel.getContainer().exists(this.container)) {
            this.reel.getContainer().add(this.container);
        }
    }
    showFrame() { }
    hideFrame() { }
    checkLayer() { }
    setCellInfo(cellMemo, stopped = false, multiplier = 0) {
        this.multiplierValue = multiplier;
        this.baseGameContainer.setVisible(true);
        this.baseSymbolImage.setVisible(true);
        this.baseSymbolSpines.forEach(s => s.setVisible(false));
        this.setMemo(cellMemo);
        this.cancelDelayedAnimationForMemo();
        //Chiamata di idle
        if (ResourcesDispatcher.GAME_CONSTANTS.ANIMATED_SYMBOLS.includes(cellMemo)) {
            this.scheduleDelayedAnimationForMemo(cellMemo);
        }
        this.on ? this.applySymbolTint(cellMemo, true) : this.applySymbolTint(cellMemo, false);
        // TODO: controllare questo codice e renderlo dinamico in base alla modalità
        // (in base potremmo non avere la modalità linkspin e quindi non ci serve mostrare i jackpot)
        if (multiplier > 0 &&
            this.scene.gameArea.gameDataManager.getJackpots().map((jackpot) => { return jackpot * window.getCurrentBet().value; }).indexOf(multiplier) === -1
            && stopped) {
            this.linkSpineValueText.setText(Utils.formatValue(multiplier));
            this.linkSpinContainer.setVisible(true);
        }
        else {
            this.linkSpineValueText.setText("");
            this.linkSpinContainer.setVisible(false);
        }
    }
    expandWild(isWinning) {
        return new Promise((resolve) => {
            this.baseSymbolImage.setVisible(false);
            const extraWildSpine = this.getExtraWildSpine();
            extraWildSpine.setVisible(false);
            this.reel.getContainer().bringToTop(this.container);
            this.container.setVisible(true);
            const animationSuffix = String(3 - (this.index - 1));
            const animationState = extraWildSpine.animationState;
            const listener = {
                complete: async () => {
                    resolve(true);
                },
                start: () => {
                    this.scene.tweens.add({
                        targets: extraWildSpine,
                        alpha: 1,
                        duration: 50,
                        ease: 'Linear',
                        onComplete: () => {
                            extraWildSpine.setVisible(true);
                        }
                    });
                    if (isWinning) {
                        this.scene.soundManager.play(ResourcesDispatcher.SOUNDS.ESPANSIONE_JOLLY);
                        this.scene.animationManager.topSideGridAnimation?.jumpscare();
                    }
                }
            };
            animationState.setAnimation(0, "On_" + animationSuffix, false);
            if (isWinning) {
                const trackEntry = animationState.addAnimation(0, "opening_" + animationSuffix, false, 0);
                trackEntry.listener = listener;
            }
            else {
                resolve(true);
            }
            // TODO: decommentare se si vuole l'expanding wild anche quando non si vince
            // else {
            //     const trackEntry = animationState.addAnimation(0, "nowin_" + animationSuffix, false, 0);
            //     trackEntry.listener = listener;
            // }
        });
    }
    contractWild() {
        return new Promise((resolve) => {
            const extraWildSpine = this.getExtraWildSpine();
            if (extraWildSpine) {
                const trackEntry = extraWildSpine.animationState.addAnimation(Cell.WinAnimationTrack, "closing_" + (3 - (this.index - 1)), false, 0);
                trackEntry.alpha = Cell.WinAnimationAlpha;
                const completeListener = {
                    complete: () => {
                        // Remove this specific listener after it is called
                        resolve(true);
                        extraWildSpine.animationState.removeListener(completeListener);
                    }
                };
                trackEntry.listener = completeListener;
            }
            else {
                resolve(true);
            }
        });
    }
    extraWildAnimation(isWinning) {
        return new Promise((resolve) => {
            this.baseSymbolImage.setVisible(false);
            const extraWildSpine = this.getExtraWildSpine();
            extraWildSpine.setVisible(true);
            this.reel.getContainer().bringToTop(this.container);
            const animationState = extraWildSpine.animationState;
            if (isWinning) {
                animationState.addAnimation(0, "animation", false, 0);
            }
            // else {
            //     this.turnOffWildAnimation();
            // }
            resolve(true);
        });
    }
    turnOffWildAnimation() {
        this.getExtraWildSpine().skeleton.color.set(0.5, 0.5, 0.5, 1);
    }
    turnOnWildAnimation() {
        this.getExtraWildSpine().skeleton.color.set(1, 1, 1, 1);
    }
    isValidGameMode() {
        const gameMode = this.gameLogicVariableManager.getCurrentGameMode();
        return gameMode === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME || gameMode === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.LINKSPIN;
    }
    setPlayAnimationListener(trackEntry, loop, resolve) {
        if (!loop) {
            trackEntry.listener = {
                complete: () => {
                    if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
                        this.getSpine(this.getMemo()).setVisible(false);
                        this.getSpine(this.getMemo()).skeleton.setToSetupPose();
                        this.baseSymbolImage.setVisible(true);
                    }
                    resolve(true);
                }
            };
        }
        else {
            resolve(true);
        }
    }
    playAnimation(loop = false) {
        return new Promise((resolve) => {
            if (!this.isValidGameMode()) {
                console.error("Mode not implemented");
                resolve(true);
                return;
            }
            const animations = this.getSymbolSpineRaw(this.getMemo()).animations;
            if (!animations) {
                resolve(true);
                return;
            }
            const trackEntry = this.getSpine(this.getMemo()).animationState.addAnimation(Cell.WinAnimationTrack, animations[0], loop);
            trackEntry.alpha = Cell.WinAnimationAlpha;
            this.getSpine(this.getMemo()).setVisible(true);
            this.baseSymbolImage.setVisible(false);
            this.setPlayAnimationListener(trackEntry, loop, resolve);
        });
    }
    playLandingAnimation() {
        let multipliers = window.GameDataManager.getLastGridMult();
        if (multipliers.length === 0) {
            multipliers = window.GameDataManager.getLinkGrid();
        }
        return new Promise((resolve) => {
            // a simple animation that zoom in and out the image
            this.baseSymbolImage.setVisible(true);
            // perform a zoom in and out animation
            this.scene.tweens.add({
                targets: this.baseSymbolImage,
                scaleX: 1.2,
                scaleY: 1.2,
                duration: 300,
                ease: 'Linear',
                yoyo: true,
                repeat: 0,
                onComplete: () => {
                    this.showLinkSpinText(multipliers[Utils.getCellGridIndex(this.reel.getIndex(), this.getIndex(), this.reel.numOfCellsPerReel, this.reel.numOfExtraCellsPerReel) ?? -1]);
                    resolve(true);
                }
            });
        });
    }
    showLinkSpinText(multiplier) {
        if (multiplier > 0 && this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_LINK) {
            this.linkSpineValueText.setText(Utils.formatValue(multiplier));
            this.linkSpinContainer.setVisible(true);
        }
        else {
            this.linkSpineValueText.setText("");
            this.linkSpinContainer.setVisible(false);
        }
    }
    stopAnimation() {
        if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
            this.cancelDelayedAnimationForMemo();
            this.getSpine(this.getMemo()).animationState.clearTrack(0);
            this.getSpine(this.getMemo()).setVisible(false);
            this.getSpine(this.getMemo()).skeleton.setToSetupPose();
            this.baseSymbolImage.setVisible(true);
        }
    }
    hideWild() {
        this.getExtraWildSpine().setVisible(false);
        this.baseSymbolImage.setVisible(false);
    }
    playIdleAnimation(memo, onComplete) {
        const animations = this.getSymbolSpineRaw(memo).animations;
        if (!animations) {
            onComplete();
            return;
        }
        const trackEntry = this.getSpine(memo).animationState.addAnimation(Cell.WinAnimationTrack, animations[2], false);
        trackEntry.alpha = Cell.WinAnimationAlpha;
        this.getSpine(memo).setVisible(true);
        this.baseSymbolImage.setVisible(false);
        trackEntry.listener = {
            complete: () => {
                if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
                    this.getSpine(memo).setVisible(false);
                    this.getSpine(memo).skeleton.setToSetupPose();
                    this.baseSymbolImage.setVisible(true);
                }
                onComplete();
            }
        };
    }
    scheduleIdleAnimationLoop(memo) {
        if (this.getMemo() !== memo)
            return;
        const delayMs = Math.floor(Math.random() * (20000 - 5000 + 1)) + 5000;
        this.delayedAnimForMemo = this.scene.time.delayedCall(delayMs, () => {
            this.playIdleAnimation(memo, () => {
                if (window.Game?.paused === false) {
                    this.scheduleIdleAnimationLoop(memo);
                }
            });
        });
    }
    scheduleDelayedAnimationForMemo(memo) {
        this.cancelDelayedAnimationForMemo();
        this.scheduleIdleAnimationLoop(memo);
    }
    cancelDelayedAnimationForMemo() {
        if (this.delayedAnimForMemo && !this.delayedAnimForMemo.hasDispatched) {
            this.delayedAnimForMemo.remove(false);
        }
        this.delayedAnimForMemo = undefined;
    }
}
Cell.OnOffAnimationTrack = 0;
Cell.WinAnimationTrack = 0;
Cell.OnOffAnimationAlpha = 1;
Cell.WinAnimationAlpha = 1;
export default Cell;
